import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { usePdfStyles } from './PdfPrintScaleContext';

/** @param {{ label: string; value: string }[]} rows */
export function LabeledPdfRows({ rows }) {
    const pdfStyles = usePdfStyles();
    return (
        <View>
            {rows
                .filter((r) => r.value != null && String(r.value).trim() !== '')
                .map((r, idx) => (
                    <View key={`${r.label}-${idx}`} style={pdfStyles.labelValueRow} wrap={false}>
                        <Text style={pdfStyles.label}>{r.label}</Text>
                        <Text style={pdfStyles.value}>{String(r.value)}</Text>
                    </View>
                ))}
        </View>
    );
}
